const isBrowser = () => process.browser;

module.exports = { isBrowser };
